import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';

import MainLayoutProgram from 'components/templates/MainLayoutProgram';
import ConfirmRemake from 'pages/ConfirmRemake';
import Home from 'pages/Home';
import { store } from 'store';

const AppContent: React.FC = () => (
  <Routes>
    <Route element={<MainLayoutProgram />}>
      <Route path="/" element={<Home />} />
      <Route path="/confirm" element={<ConfirmRemake />} />
    </Route>
  </Routes>
);

const App: React.FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

const AppWrapper: React.FC = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppWrapper;
